import operate from './operate.vue'

export default function () {
  return [
    {
      title: '员工姓名',
      isEdit: true,
      [$field]: 'userName',
    },
    {
      title: '性别',
      isEdit: true,
      [$field]: 'gender'
    },
    {
      title: '工号',
      isEdit: true,
      [$field]: 'userCode'
    },
    {
      title: '政治面貌',
      isEdit: true,
      [$field]: 'political'
    },
    {
      title: '所在组织',
      isEdit: true,
      [$field]: 'organization'
    },
    {
      'title': '操作',
      'width': 200,
      [$field]: 'operate',
      'isOperate': true,
      'slotComponent': operate
    }
  ]
}
